import { StatusSymbol, type TagTone } from '../../ui';

/**
 * A SELECT OPTION'S COLOUR, AS A DOT: a thin wrapper over the one status mark (BR-PARTS,
 * DESIGN.md B1). The tag circle's construction, its tones and its sources moved into
 * `ui/StatusSymbol` (the `tone` form), so this file draws nothing of its own; it stays so the
 * rest of the CRM's callers keep their import while the rest-of-CRM round decides which of these
 * dots become the four status shapes.
 */
export function TagDot({ tone }: { readonly tone: TagTone }) {
  return <StatusSymbol tone={tone} />;
}
